import React from 'react';

export const CateringAddOnField = ({ addOn, children }) => {
  return (
    <div key={addOn.id}>
      <span className="tw-body-2-m">{addOn.title}</span>
      <p className="tw-body-1 no-margin text-gray-600 margin-sm-top">
        {addOn.subtext}
      </p>
      {addOn.description && (
        <p className="no-margin margin-md-top">{addOn.description}</p>
      )}
      <div className="margin-md-top">{children}</div>
    </div>
  );
};
